import { ref } from "#imports";
const show = ref(false);
const confirmProps = ref({
  title: "",
  message: "",
  actions: []
});
const confirmHandlers = ref({});
export const DefaultConfirmDeleteActions = [
  { locale: "global.buttons.delete", action: "delete", attention: true },
  { locale: "global.buttons.cancel", action: "cancel" }
];
export const DefaultConfirmActionConfig = {
  title: "global.confirm",
  message: "",
  actions: [
    { locale: "global.buttons.apply", action: "confirm" },
    { locale: "global.buttons.cancel", action: "cancel" }
  ]
};
const component = ref({});
export function useConfirmModal() {
  return {
    show,
    confirmProps,
    confirmHandlers,
    component
  };
}
